import React, { useEffect } from "react"
import styled from "styled-components"
import { Link, navigate } from "gatsby"

import authStore from "../stores/auth"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import logo from "../imgs/white-logo.png"
import logoRegular from "../imgs/logo-hq.png"
import quotes from "../imgs/quotes.svg"
import prevArrowGrey from "../imgs/prev-arrow-grey.png"
import prevArrowBlue from "../imgs/prev-arrow-blue.png"
import nextArrowGrey from "../imgs/next-arrow-grey.png"
import nextArrowBlue from "../imgs/next-arrow-blue.png"

import blueDot from "../imgs/blue-dot.png"

import featAnonymous from "../imgs/feat-anonymous.svg"
import featBestPricing from "../imgs/feat-best-pricing.svg"
import featDedicated from "../imgs/feat-dedicated.svg"
import featEthicalAndLegal from "../imgs/feat-ethical-and-legal.svg"
import featHugeIpPool from "../imgs/feat-huge-ip-pool.svg"
import featInstantAccess from "../imgs/feat-instant-access.svg"
import featIpRotation from "../imgs/feat-ip-rotation.svg"
import featLimitless from "../imgs/feat-limitless.svg"
import featPremiumSpeed from "../imgs/feat-premium-speed.svg"
import featPremiumSupport from "../imgs/feat-premium-support.svg"
import featRaw from "../imgs/feat-raw.svg"
import featReliable from "../imgs/feat-reliable.svg"
import featStaticMobileIps from "../imgs/feat-static-mobile-ips.svg"
import featUsa from "../imgs/feat-usa.svg"
import gswrpBuyNow from "../imgs/gswrp-buy-now.svg"
import gswrpSeeProducts from "../imgs/gswrp-see-products.svg"
import discountRibbon from "../imgs/discount-ribbon.svg"
import bannerGirl from "../imgs/banner-girl.jpg"
import copyToClipboard from "../utils/copy-to-clipboard"

import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import DiscountsStore from "../stores/discounts"

import { Subscribe } from "unstated"

const LogoStyledDiv = styled.div`
  display: inline-flex;
  flex-flow: row;
  align-items: center;
`
const LogoImg = styled.img`
  height: ${props => (props.height ? props.height : props.dark ? 18 : 30)}px;
  margin-right: ${props => (props.dark ? 5 : 10)}px;
`
const LogoPara = styled.p`
  color: ${props => (props.dark ? "#667AF4" : "white")};
  font-size: ${props => (props.fs ? props.fs : props.dark ? 12 : 20)}px;
  margin: 0;
  font-weight: ${props => (props.fw ? props.fw : props.dark ? 700 : 500)};
`
export function LogoDiv({ dark, height, fs, fw }) {
  const logoImg = dark ? logoRegular : logo
  const homepageUrl =
    process.env.GATSBY_ACTIVE_ENV !== "production"
      ? "https://staging.mountproxies.com/"
      : "https://mountproxies.com/"
  return (
    <Link to={homepageUrl} style={{ textDecoration: "none" }}>
      <LogoStyledDiv>
        <LogoImg dark={dark} alt="logo" src={logoImg} height={height} />
        <LogoPara dark={dark} fs={fs} fw={fw}>
          MountProxies
        </LogoPara>
      </LogoStyledDiv>
    </Link>
  )
}

const MainHeading1 = styled.h1`
  z-index: 5;
  font-size: ${props => props.fontSizePx};
  color: white;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  margin-top: ${props => props.marginTopPx};
  max-width: 85vw;
`
export function MainHeading(props) {
  return (
    <MainHeading1 fontSizePx={props.fontSizePx} marginTopPx={props.marginTopPx}>
      {props.children}
    </MainHeading1>
  )
}

const SecondaryHeading2 = styled.h2`
  z-index: 5;
  font-size: ${props => props.fontSizePx};
  color: white;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  margin-top: ${props => props.marginTopPx};
`
export function SecondaryHeading(props) {
  return (
    <SecondaryHeading2
      fontSizePx={props.fontSizePx}
      marginTopPx={props.marginTopPx}
    >
      {props.children}
    </SecondaryHeading2>
  )
}

const StyledSigninButton = styled.button`
  position: relative;
  z-index: 5;
  width: 150px;
  margin: 0 auto;
  padding: 16px;
  text-align: center;
  border-radius: 12px;
  border: 1px transparent;
  box-shadow: 0 0 0 2px hsla(216, 33.3%, 14.7%, 0.1),
    0 1px 3px 0 hsla(216, 12.4%, 39.4%, 0.06);
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  margin-top: ${props => props.marginTopPx};
  margin-bottom: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
`
export function SigninButton(props) {
  const handleClick = e => {
    props.onClick ? props.onClick(e) : navigate("/products")
  }

  return (
    <StyledSigninButton
      backgroundColor={props.backgroundColor}
      color={props.color}
      marginTopPx={props.marginTopPx}
      onClick={handleClick}
    >
      {props.children}
    </StyledSigninButton>
  )
}

// rock proxy features cards styled components
export const RockFeatureCard = styled.div`
  box-shadow: rgba(65, 155, 249, 0.1) 0px 0px 0px 1px,
    rgba(65, 155, 249, 0) 0px 0px 0px 0px,
    rgba(65, 155, 249, 0.08) 0px 12px 50px 0px,
    rgba(158, 158, 163, 0.25) 0px 2px 10px 0px;
  background-color: #ffffff;
  min-height: 300px;
  margin-top: 16px;
  margin-right: 16px;
  @media (max-width: 768px) {
    width: 100%;
    margin: 12px auto;
  }
  @media (min-width: 769px) and (max-width: 1060px) {
    width: 45%;
  }
  @media (min-width: 1061px) {
    width: 31%;
  }
  border-radius: 8px;
  cursor: ${props => props.cursor};
`
export const RockFeatureLogo = styled.img`
  height: 140px;
  display: block;
  margin: 0px auto;
  padding-top: 24px;
`
export const RockFeatureHeading = styled.h3`
  padding-top: 10px;
  text-align: center;
`
export const RockFeaturePara = styled.p`
  display: block;
  width: 70%;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 12px;
`
export const RockFeatureLinkTo = styled.p`
  margin-left: auto;
  margin-right: 10%;
  display: block;
  width: 50%;
  text-align: right;
  font-weight: 700;
`
export const RockFeatureLinkArrow = styled.img`
  height: 10px;
  padding-left: 10px;
`
export const FeaturesArr = [
  {
    key: 1,
    logo: featDedicated,
    heading: "Dedicated",
    para:
      "No splicing, no sharing. Your proxy is exclusive to you and only you.",
  },
  {
    key: 2,
    logo: featRaw,
    heading: "Raw",
    para: "Connect and manage multiple accounts per proxy without issues.",
  },
  {
    key: 3,
    logo: featLimitless,
    heading: "Limitless",
    para:
      "Unlimited 5G LTE, 24/7 without limits on threads, connections or PCs.",
  },
  {
    key: 4,
    logo: featUsa,
    heading: "USA",
    para: "Proxy IPs located in the United States.",
  },
  {
    key: 5,
    logo: featHugeIpPool,
    heading: "Huge IP Pool",
    para:
      "Access to millions of IPs distributed across multiple network providers..",
  },
  {
    key: 7,
    logo: featIpRotation,
    heading: "IP Rotation",
    para:
      "Optionally, set custom rotation intervals, whenever, and keep your IPs fresh.",
  },
  {
    key: 8,
    logo: featStaticMobileIps,
    heading: "Static Mobile IPs",
    para:
      "Powered by AT&T Mobility; the largest U.S. wireless provider―hands down.",
  },
  {
    key: 9,
    logo: featReliable,
    heading: "Reliable",
    para:
      "Top-tier hardware and systems with max security, sustainability and uptime.",
  },
  {
    key: 10,
    logo: featAnonymous,
    heading: "Anonymous",
    para: "No tracking. No logging.",
  },
  {
    key: 11,
    logo: featPremiumSpeed,
    heading: "Premium Speed",
    para:
      "Superfast speeds allow the running of multiple accounts & actions easily.",
  },
  {
    key: 12,
    logo: featPremiumSupport,
    heading: "Premium Support",
    para: "We’re a USA-based team of support staff who are here to help 24/7.",
  },
  {
    key: 13,
    logo: featInstantAccess,
    heading: "Instant Access",
    para: "No waiting. Your proxies are completely self-service.",
  },
  {
    key: 14,
    logo: featEthicalAndLegal,
    heading: "Ethical and Legal",
    para:
      "Enterprise business contracts with wireless providers - no sharing modems.",
  },
  {
    key: 15,
    logo: featBestPricing,
    heading: "Best Pricing",
    para:
      "We offer the highest quality service with prices that will make you smile.",
  },
]
export const FeatureCard = ({
  logo,
  heading,
  para,
  widthPercentage,
  linkto = null,
}) => {
  return (
    <RockFeatureCard
      cursor={linkto ? "pointer" : "default"}
      widthPercentage={widthPercentage}
      onClick={e => {
        if (linkto === "/signup") {
          authStore.login()
        } else if (linkto) {
          navigate(linkto)
        }
        e.preventDefault()
      }}
    >
      <RockFeatureLogo src={logo} alt="feature-logo"></RockFeatureLogo>
      <RockFeatureHeading>{heading}</RockFeatureHeading>
      <RockFeaturePara>{para}</RockFeaturePara>
    </RockFeatureCard>
  )
}

export const ReviewsDiv = styled.div`
  width: ${props => (props.isMobile ? "200px" : "300px")};
  background-image: url(${quotes});
  background-repeat: no-repeat;
  background-size: ${props => (props.isMobile ? "80px auto" : "130px auto")};
  background-position: right top;
  border: 1px solid transparent;
  margin: 100px auto 0;
  display: block;
`
export const ReviewsHeading = styled.h1`
  text-align: center;
  font-size: 42px;
  display: block;

  @media (min-width: 768px) {
    font-size: 48px;
    line-height: 58px;
  }
`
// review components
const SliderContainer = styled.div`
  width: 94%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
`
const SliderPrevNext = styled.div`
  width: 10%;
`
const SliderButton = styled.span`
  background-image: url(${props => props.backgroundImg});
  background-repeat: no-repeat;
  display: block;
  height: 48px;
  width: 30px;
  margin: 0 auto;
  margin-top: 20px;
  cursor: pointer;

  &:hover {
    background-image: url(${props => props.backgroundImgBlue});
  }
`

const SliderCenter = styled.div`
  width: 80%;
`

const RockCarouselCard = styled.div`
  width: ${props => (props.isMobile ? "90%" : "80%")};
  display: block;
  margin: 0 auto;
  box-shadow: rgba(65, 155, 249, 0.01) 0px 0px 0px 0px,
    rgba(65, 155, 249, 0) 0px 0px 0px 0px,
    rgba(2, 7, 13, 0.01) 0px 12px 50px 0px,
    rgba(158, 158, 163, 0.01) 0px 2px 0px 2px;
`
const RockCarouselCardFlex = styled.div`
  width: ${props => (props.isMobile ? "80%" : "70%")};
  margin: 0 auto;
  display: flex;
  flex-flow: column;
`
const RockCarouselPara = styled.p`
  margin: 15px 0;
  font-size: 16;
  line-height: 26px;
  color: #878e94;
`
const RockCarouselName = styled.h4`
  margin: 0;
  color: #324fee;
`

const ReviewerInfoFlex = styled.div`
  margin-top: 30px;
  display: flex;
  flex-flow: row;
`
const CarouselCard = ({ isMobile, para, name }) => {
  return (
    <RockCarouselCard isMobile={isMobile}>
      <RockCarouselCardFlex isMobile={isMobile}>
        <RockCarouselPara>{para}</RockCarouselPara>
        <ReviewerInfoFlex>
          <div>
            <RockCarouselName>{name}</RockCarouselName>
          </div>
        </ReviewerInfoFlex>
      </RockCarouselCardFlex>
    </RockCarouselCard>
  )
}
const ReviewsArr = [
  {
    key: 1,
    para:
      "These are the fastest 5G proxies I’ve used, although I’ve only been using them for two weeks I’m pretty sure nothing else will be needed. I’m able to run 10 IG accounts per proxy and at these prices, I’m thinking of expanding!",
    pic: blueDot,
    name: "Affiliate Marketer",
    post: "CEO of Cool Company",
  },
  {
    key: 2,
    para:
      "We’ve built an army of over 200 IG accounts to broadcast our product using these proxies. We needed inexpensive non-rotatating proxies to achieve this, and our gorwth has been significant accross all our accounts. We’ve used other providers in the past but when you need this many proxies, going with MountProxies was the easy choice - all the quality and support at way less of a price.",
    pic: blueDot,
    name: "Affiliate Marketer",
    post: "CEO Cool Company",
  },
  {
    key: 3,
    para:
      "Their support emails are fast, they helped me when I was confused, and I was able to use my proxy to finally achieve my goals. I’d tried so many other ways in the past, and finally getting a 5G proxy was the solution.",
    pic: blueDot,
    name: "Affiliate Marketer",
    post: "CEO Cool Company",
  },
  {
    key: 4,
    para:
      "Their support emails are fast, they helped me when I was confused, and I was able to use my proxy to finally achieve my goals. I’d tried so many other ways in the past, and finally getting a 5G proxy was the solution.",
    pic: blueDot,
    name: "Affiliate Marketer",
    post: "CEO Cool Company",
  },
  {
    key: 5,
    para:
      "Really solid proxies and a much better price than who I was using before. Easy choice. Works well. Oh and speeds are FAST.",
    pic: blueDot,
    name: "Affiliate Marketer",
    post: "CEO Cool Company",
  },
]

export const RockReviews = ({ isMobile = false }) => {
  let slider
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const next = () => {
    if (slider) {
      slider.slickNext()
    }
  }

  const prev = () => {
    if (slider) {
      slider.slickPrev()
    }
  }

  return (
    <SliderContainer>
      <SliderPrevNext>
        <SliderButton
          onClick={e => {
            prev()
            e.preventDefault()
          }}
          backgroundImg={prevArrowGrey}
          backgroundImgBlue={prevArrowBlue}
        ></SliderButton>
      </SliderPrevNext>

      <SliderCenter>
        <Slider
          ref={c => {
            slider = c
          }}
          {...settings}
        >
          {ReviewsArr.map(item => {
            return (
              <CarouselCard
                key={item.key}
                isMobile={isMobile}
                para={item.para}
                pic={item.pic}
                name={item.name}
                post={item.post}
              ></CarouselCard>
            )
          })}
        </Slider>
      </SliderCenter>
      <SliderPrevNext>
        <SliderButton
          onClick={e => {
            next()
            e.preventDefault()
          }}
          backgroundImg={nextArrowGrey}
          backgroundImgBlue={nextArrowBlue}
        ></SliderButton>
      </SliderPrevNext>
    </SliderContainer>
  )
}

export const GetStartedArr = [
  {
    key: 2,
    logo: gswrpSeeProducts,
    heading: "See Products",
    para: "See our pricing options and details.",
    linkto: "/products",
  },
  {
    key: 3,
    logo: gswrpBuyNow,
    heading: "Buy Now",
    para: "Create an account and get your proxies.",
    linkto: "/signup",
  },
]

export const DesktopDiv5 = styled.div`
  margin-top: 100px;
  width: 100%;
  background-color: #667af4;
  color: white;
`
export const DesktopDiv5flex = styled.div`
  display: flex;
  flex-flow: row;
`

export const DesktopDiv5left = styled.div`
  @media (max-width: 1100px) {
    width: 30%;
  }
  @media (min-width: 1101px) {
    width: 40%;
  }
  padding: 30px 20px 20px 10%;
`
export const DesktopDiv5right = styled.div`
  @media (max-width: 961px) {
    flex-direction: column;
  }

  @media (max-width: 1100px) {
    width: 70%;
  }
  @media (min-width: 1101px) {
    width: 60%;
  }
  display: flex;
  flex-flow: row;
  padding: 30px 10% 20px 20px;
`

export const DesktopPagesCol = styled.div`
  display: flex;
  flex: 0.3;
  flex-flow: column;
`

export const DesktopSocialCol = styled.div`
  display: flex;
  flex: 0.3;
  flex-flow: row;
`

export const DesktopSocialAnchor = styled.a`
  height: 24px;
  width: 24px;
  margin-right: 40px;
`

export const DesktopSocialImg = styled.img`
  height: 20px;
`
export const DesktopDiv5hr = styled.div`
  width: 80%;
  display: block;
  margin: 0 auto;
  border: 0.1px solid white;
`
export const DesktopDiv5copyrights = styled.div`
  width: 80%;
  display: block;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;
`

export const DesktopNavLinksDiv = styled.div`
  margin-left: auto;
  display: inline-flex;
  flex-flow: row;
  align-items: center;
`

export const DesktopNavLink = styled(Link)`
  color: white;
  text-decoration: none;
  margin-right: 40px;
`

export const MobileDivFooter = styled.div`
  margin-top: 100px;
  width: 100%;
  height: 320px;
  background-color: #667af4;
  color: white;
`
export const MobileFooterFlex = styled.div`
  display: flex;
  flex-flow: row;
`
export const MobileFooterLeft = styled.div`
  display: flex;
  flex-flow: column;
  flex: 0.4;
  padding-top: 20px;
  padding-left: 50px;
`
export const MobileFooterRight = styled.div`
  display: flex;
  flex-flow: column;
  flex: 0.4;
  padding-top: 20px;
`
export const MobileFooterSocial = styled.div`
  display: flex;
  flex-flow: row;
`
export const MobileSocialAnchor = styled.a`
  height: 32px;
  width: 32px;
  margin-right: 20px;
`

export const MobileSocialImg = styled.img`
  height: 30px;
  margin-right: 20px;
`
export const MobileDivFooterHr = styled.div`
  width: 98%;
  display: block;
  margin: 0 auto;
  border: 0.1px solid white;
`
export const MobileDiv5copyrights = styled.div`
  width: 80%;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  text-align: center;
`

const MobileProductsContainer = styled.div`
  height: 600px;
  width: 263px;
  margin: 10px auto;
`

export const MobileProductsSlider = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const data = useStaticQuery(graphql`
    query {
      everestImage: file(relativePath: { eq: "slider_everest.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      kiliImage: file(relativePath: { eq: "slider_kilimanjaro.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      fujiImage: file(relativePath: { eq: "slider_fuji.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)

  return (
    <MobileProductsContainer>
      <Slider {...settings}>
        <Img fluid={data.everestImage.childImageSharp.fluid} alt="Everest" />
        <Img fluid={data.kiliImage.childImageSharp.fluid} alt="Kilimanjaro" />
        <Img fluid={data.fujiImage.childImageSharp.fluid} alt="Fuji" />
      </Slider>
    </MobileProductsContainer>
  )
}

const BannerContainer = styled.div`
  padding: 0 10%;
  display: flex;
  background: linear-gradient(to right, #ffe700, #ffdf00);
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }

  .new-users-container {
    position: relative;
    z-index: 0;
  }

  .new-users-container:after {
    z-index: -1;
    position: absolute;
    content: "";
    height: 2px;
    bottom: 50%;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 80%;
    background: black;
  }

  .new-users-text {
    background: #ffe700;
    color: black;
    font-size: 18px;
    font-weight: 700;
    display: inline-block;
    padding: 0 12px;
  }

  .discount {
    font-size: 32px;
    line-height: 1.2;
    font-weight: 300;
    margin-top: 20px;
  }

  .discount-remaining {
    font-weight: 700;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background: #f9f9f9;
    padding: 3px 18px;
    letter-spacing: 1px;
    font-size: 32px;
    line-height: 120%;
    border-radius: 5px;
    -webkit-filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    display: inline-block;
    margin: 0 10px 24px;
  }

  .italic {
    font-style: italic;
  }

  .discount-code-container {
    position: relative;
    background: white;
    padding: 4px 6px;
    font-weight: 700;
    margin-left: 10px;
  }

  .discount-code-container:after {
    content: "";
    background-image: url("${discountRibbon}");
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    width: 80%;
    height: 100%;
    transition: all 0.35s ease-in;
  }

  .discount-code-container:hover:after {
    width: 0%;
  }

  .banner-girl {
    @media screen and (max-width: 768px) {
      display: none;
    }

    max-width: 33%;
    max-height: 150px;
  }
`

const BannerItem = styled.div`
  padding: 12px 24px;
  text-align: center;
`

const SaleBannerDisplay = ({ store }) => {
  useEffect(() => {
    store.fetchDiscounts()
  }, [store])

  const discount = store.state.discounts[0]

  if (!discount) {
    return null
  }

  return (
    <BannerContainer>
      <BannerItem>
        <div className="new-users-container">
          <span className="new-users-text">{discount.name}</span>
        </div>
        <div className="discount">{discount.description}</div>
      </BannerItem>
      <BannerItem>
        <div>
          Only{" "}
          <span className="discount-remaining">
            {discount.total - discount.claimed}
          </span>
          new users left
        </div>
        <div className="">
          <span className="italic">Use promo code:</span>
          <span
            tabIndex="1"
            role="button"
            className="discount-code-container"
            onClick={() => {
              copyToClipboard(discount.code)
              alert("Coupon code copied!")
            }}
          >
            {discount.code}
          </span>
        </div>
      </BannerItem>
      <img className="banner-girl" src={bannerGirl} alt="Get discount" />
    </BannerContainer>
  )
}

export const SaleBanner = () => (
  <Subscribe to={[DiscountsStore]}>
    {store => <SaleBannerDisplay store={store} />}
  </Subscribe>
)
